import React from 'react';
import { Modal as AntdModal, Button, Radio } from 'antd';
import { DatePicker, ConfigProvider } from 'antd';
import { JobType, jobTypeAsString } from "@leedpulse-monorepo/enums";
import 'moment/locale/fr';
import frFR from 'antd/lib/locale/fr_FR';
import moment from 'moment';

moment.locale('fr');
interface ModalProps {
  visible: boolean;
  title: string;
  onClose: () => void;
  onConfirm: (jobType: JobType, scheduledTime?: number) => void;
  confirmText?: string;
}

const Modal: React.FC<ModalProps> = ({
  visible,
  title,
  onClose,
  onConfirm,
  confirmText = 'Créer',
}) => {
  const [selectedJobType, setSelectedJobType] = React.useState<JobType | null>(null);
  const [selectedDate, setSelectedDate] = React.useState<moment.Moment | null>(null);

  const handleConfirm = () => {
    if (selectedJobType) {
      if (
        (selectedJobType === JobType.reply)
        && selectedDate
      ) {
        const scheduledTime = selectedDate.valueOf();
        onConfirm(selectedJobType, scheduledTime);
      } else {
        onConfirm(selectedJobType);
      }
    }
  };

  const filteredJobTypes = [
    JobType.reply,
    JobType.followUp30Days,
    JobType.followUp90Days,
    JobType.followUp180Days,
    JobType.followUp365Days,
  ];

  return (
    <AntdModal
      open={visible}
      title={<h2 style={{ fontSize: '24px', marginBottom: '20px' }}>{title}</h2>}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Annuler
        </Button>,
        <Button
          key="confirm"
          type="primary"
          onClick={handleConfirm}
          disabled={
            (selectedJobType === JobType.reply) && !selectedDate
          }
        >
          {confirmText}
        </Button>,
      ]}
    >
      <div>
        <Radio.Group
          onChange={(e) => setSelectedJobType(e.target.value)}
          value={selectedJobType}
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          {filteredJobTypes.map((type) => (
            <Radio
              key={type}
              value={type}
              style={{ marginBottom: '10px', fontSize: '16px' }}
            >
              {jobTypeAsString(type)}
            </Radio>
          ))}
        </Radio.Group>

        {(selectedJobType === JobType.reply) && (
          <div style={{ marginTop: '20px' }}>
            <ConfigProvider locale={frFR}>
              <DatePicker
                showTime={{ format: 'HH:mm' }}
                format="DD-MM-YYYY HH:mm"
                onChange={(date) => setSelectedDate(date)}
                value={selectedDate}
                style={{ width: '100%' }}
                placeholder="Sélectionner la date et l'heure"
                disabledDate={(current) => current && current < moment().startOf('day')}
              />
            </ConfigProvider>
          </div>
        )}
      </div>
    </AntdModal>
  );
};

export default Modal;
